import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {createAuthorizationHeader} from "../../utils/headers";
import {Observable} from "rxjs";
import {GlobalService} from "../../global.config";

@Injectable({
  providedIn: 'root'
})
export class DriverService {
  constructor(
    private _http: HttpClient,
    private globalService: GlobalService,
    ) { }

  getOne(idDriver: number): Observable<any> {
    let headers = createAuthorizationHeader();
    return this._http
      .get(this.globalService.dns + "drivers/" + idDriver, { headers: headers });
  }

  getOneByIdUser(idUser: number): Observable<any> {
    let headers = createAuthorizationHeader();
    return this._http
      .get(this.globalService.dns + "drivers/user/" + idUser, { headers: headers });
  }
}
